






































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { XProcess } from '@/models/xprocess';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'XProcessWorksheet',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class XProcessWorksheet extends Vue {
    @Prop() private selectedPhase: XProcess;

    private haveXWorksheet(xProcess: XProcess) {
        return xProcess.x_worksheet !== undefined;
    }

    private getXClass(xProcess: XProcess) {
        if (!this.haveXWorksheet(xProcess)) {
            return '';
        } else {
            let done = true;
            if (xProcess.x_worksheet) {
                xProcess.x_worksheet.x_applied_lessons.forEach((xAppliedLesson: XAppliedLesson) => {
                    if (!xAppliedLesson.done) {
                        done = false;
                        return;
                    }
                });
            }

            return !done ? 'is-danger' : 'is-success';
        }
    }

    private showWorksheet(xProcess: XProcess, onlyPR: boolean = false) {
        if (xProcess.x_worksheet !== null) {
            this.$router.push({
                name: 'WorksheetView',
                query: {
                    id: xProcess.x_worksheet.id.toString(),
                    onlyPR: String(onlyPR),
                    type: 'x',
                },
            });
        } else {
            this.$router.push({
                name: 'CreateWorksheetX',
                query: {
                    phaseId: xProcess.id + '',
                },
            });
        }
    }

    private getClassHB(xProcess: XProcess) {
        if (xProcess.x_worksheet === null) {
            return '';
        } else {
            let done = true;
            xProcess.x_worksheet.x_applied_lessons.forEach((xAppliedLesson: XAppliedLesson) => {
                if (!xAppliedLesson.done) {
                    done = false;
                    return;
                }
            });

            return !done ? 'is-danger' : 'is-success';
        }
    }

    private getClassPR(xProcess: XProcess) {
        if (xProcess.x_worksheet === null) {
            return '';
        } else {
            let needsCheck = false;
            let hasBeenChecked = true;
            xProcess.x_worksheet.x_applied_lessons.forEach((xAppliedLesson: XAppliedLesson) => {
                if (xAppliedLesson.needscheck) {
                    needsCheck = true;
                    if (!xAppliedLesson.checked) {
                        hasBeenChecked = false;
                        return;
                    }
                }
            });

            return needsCheck ? (hasBeenChecked ? 'is-success' : 'is-danger') : '';
        }
    }
}
